// frontend/src/hooks/useJefeMetrics.js
// Hook para obtener métricas rápidas del Jefe de Proyecto (invitaciones pendientes y tareas en revisión)
import { useEffect, useState } from 'react';
import { fetchAuth } from '../utils/api';
import { getUserRole } from '../utils/auth';

export function useJefeMetrics(userRole) {
  const [pendingInvitations, setPendingInvitations] = useState(0);
  const [tasksInReview, setTasksInReview] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let abort = false;
    async function load() {
      try {
        setLoading(true);
        setError(null);
        const role = userRole || await getUserRole();
        if (role !== 'JEFE') {
          // No ejecutar llamadas si no es JEFE
          if (!abort) {
            setPendingInvitations(0);
            setTasksInReview(0);
            setLoading(false);
          }
          return;
        }
        const data = await fetchAuth('/api/jefe/proyectos/');
        if (abort) return;
        const proyectos = data.proyectos || [];
        const pendientes = proyectos.filter(p => (p.estado || '').toString().toUpperCase() === 'PENDIENTE').length;
        setPendingInvitations(pendientes);
        // Cargar tareas del jefe y contar EN_REVISION
        try {
          const tareasData = await fetchAuth('/api/jefe/tareas/');
          const tareas = tareasData.tareas || [];
          const enRev = tareas.filter(t => {
            const e = String(t.estado || '');
            return e === 'EN_REVISION' || e === 'En Revisión' || e.toLowerCase().includes('revision');
          }).length;
          setTasksInReview(enRev);
        } catch {
          setTasksInReview(0);
        }
      } catch (e) {
        if (!abort) {
          // Silenciar 403 para roles no-jefe en caso de carreras
          if (e?.status === 403) {
            setError(null);
          } else {
            setError(e.message || 'Error cargando métricas');
          }
        }
      } finally {
        if (!abort) setLoading(false);
      }
    }
    load();
    // Intervalo ligero para refrescar cada 60s
    const id = setInterval(load, 60000);
    return () => { abort = true; clearInterval(id); };
  }, [userRole]);

  return { pendingInvitations, tasksInReview, loading, error };
}
